import angular from 'angular'
import './trades.service'

angular
  .module('admin.trades', ['admin.trades.service'])
  .controller('TradesAdminCtrl', TradesAdminCtrl)

/** @ngInject */
function TradesAdminCtrl(TradesService) {
  var vm = this
  vm.items = []

  function load() {
    TradesService.list().then(function(result) {
      vm.items = result.results
    })
  }

  load()
}
